// src/components/album/StepFinalize.jsx
import React from 'react';
import {
    VStack,
    Box,
    Heading,
    Text,
    SimpleGrid,
    HStack,
    Divider,
    Badge,
    Button,
    Image,
    Flex,
    Spinner,
    useBreakpointValue,
} from '@chakra-ui/react';
import { FiDownload } from 'react-icons/fi';

const StepFinalize = ({
    albumTitle,
    selectedImages,
    paperSize,
    orientation,
    pageLayout,
    dedication,
    specialPages,
    onGeneratePDF,
    isGeneratingPdf
}) => {
    const buttonSize = useBreakpointValue({ base: "sm", md: "md" });

    return (
        <VStack spacing={6} align="stretch" w="100%">
            <Heading size="md" color="gray.700">Finalizar e Baixar</Heading>

            <Box
                p={{ base: 4, md: 6 }}
                borderWidth="1px"
                borderRadius="lg"
                bg="white"
            >
                <VStack spacing={4} align="stretch">
                    <Heading size={{ base: "sm", md: "md" }} noOfLines={2}>
                        {albumTitle || "Meu Livro de Colorir"}
                    </Heading>

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 2, md: 4 }}>
                        <HStack>
                            <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                                Quantidade de páginas:
                            </Text>
                            <Text fontSize={{ base: "sm", md: "md" }}>
                                {selectedImages.length + 2 + specialPages.length}
                            </Text>
                        </HStack>

                        <HStack>
                            <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                                Tamanho:
                            </Text>
                            <Text fontSize={{ base: "sm", md: "md" }}>
                                {paperSize === 'A4' ? 'A4 (21×29.7cm)' :
                                    paperSize === 'A5' ? 'A5 (14.8×21cm)' :
                                        'A6 (10.5×14.8cm)'}
                            </Text>
                        </HStack>

                        <HStack>
                            <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                                Orientação:
                            </Text>
                            <Text fontSize={{ base: "sm", md: "md" }}>
                                {orientation === 'portrait' ? 'Retrato (vertical)' : 'Paisagem (horizontal)'}
                            </Text>
                        </HStack>

                        <HStack>
                            <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                                Layout:
                            </Text>
                            <Text fontSize={{ base: "sm", md: "md" }}>
                                {pageLayout === 'one_per_page' ? 'Uma imagem por página' : 'Duas imagens por página'}
                            </Text>
                        </HStack>
                    </SimpleGrid>

                    {dedication && (
                        <Box>
                            <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                                Dedicatória:
                            </Text>
                            <Text fontStyle="italic" fontSize={{ base: "sm", md: "md" }} noOfLines={3}>
                                "{dedication}"
                            </Text>
                        </Box>
                    )}

                    {specialPages.length > 0 && (
                        <Box>
                            <Text fontWeight="bold" fontSize={{ base: "sm", md: "md" }}>
                                Páginas especiais incluídas:
                            </Text>
                            <HStack spacing={2} wrap="wrap">
                                {specialPages.includes('instructions') && (
                                    <Badge colorScheme="blue">Instruções</Badge>
                                )}
                                {specialPages.includes('certificate') && (
                                    <Badge colorScheme="green">Certificado</Badge>
                                )}
                                {specialPages.includes('about') && (
                                    <Badge colorScheme="purple">Sobre o artista</Badge>
                                )}
                            </HStack>
                        </Box>
                    )}

                    <Divider my={2} />

                    <Box>
                        <Text fontWeight="bold" mb={2} fontSize={{ base: "sm", md: "md" }}>
                            Miniatura das páginas:
                        </Text>
                        {selectedImages.length > 0 ? (
                            <SimpleGrid columns={{ base: 3, sm: 4, md: 6 }} spacing={2}>
                                {selectedImages.slice(0, 6).map((image, index) => (
                                    <Image
                                        key={index}
                                        src={image.generated_image_url}
                                        alt={image.title}
                                        boxSize={{ base: "50px", md: "60px" }}
                                        objectFit="cover"
                                        borderRadius="md"
                                        fallback={<Spinner size="sm" />}
                                    />
                                ))}
                                {selectedImages.length > 6 && (
                                    <Flex
                                        boxSize={{ base: "50px", md: "60px" }}
                                        bg="gray.100"
                                        borderRadius="md"
                                        align="center"
                                        justify="center"
                                    >
                                        <Text fontWeight="bold">+{selectedImages.length - 6}</Text>
                                    </Flex>
                                )}
                            </SimpleGrid>
                        ) : (
                            <Text color="gray.500" fontStyle="italic">Nenhuma imagem adicionada</Text>
                        )}
                    </Box>

                    {/* ADICIONAR AQUI O LOGO */}
                    <Divider my={4} />
                    <Flex justify="center" align="center" gap={2}>
                        <Image
                            src="/img/LogoFINAL.png"
                            alt="Draw Your Goods"
                            height="30px"
                            opacity={0.7}
                        />
                        <Text fontSize="sm" color="gray.500">
                            Criado com Draw Your Goods
                        </Text>
                    </Flex>
                </VStack>
            </Box>

            <Divider />

            <VStack spacing={4}>
                <Button
                    colorScheme="blue"
                    size={buttonSize}
                    leftIcon={<FiDownload />}
                    onClick={onGeneratePDF}
                    isLoading={isGeneratingPdf}
                    loadingText="Gerando PDF..."
                    isDisabled={selectedImages.length === 0}
                    width={{ base: "100%", md: "auto" }}
                >
                    Baixar Livro de Colorir em PDF
                </Button>

                <Text fontSize="sm" color="gray.500" textAlign="center">
                    Dicas para impressão: Use papel branco de 120g ou mais espesso para melhores resultados.
                </Text>
            </VStack>
        </VStack>
    );
};

export default StepFinalize;